"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTipProperty = exports.tipPropertyDefinition = void 0;
exports.tipPropertyDefinition = {
    view: { label: 'Tip' },
    constraints: [
        {
            name: 'orderedProperties',
            argument: [
                'tip-title',
                'tip-display-sidefact',
                'tip-content-container',
            ],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'tip',
};
const isTipProperty = (prop) => {
    return prop.name === exports.tipPropertyDefinition.name;
};
exports.isTipProperty = isTipProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGlwLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvdGlwLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEscUJBQXFCLEdBQUc7SUFDbkMsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLEtBQUssRUFBRTtJQUN0QixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxtQkFBbUI7WUFDekIsUUFBUSxFQUFFO2dCQUNSLFdBQVc7Z0JBQ1gsc0JBQXNCO2dCQUN0Qix1QkFBdUI7YUFDeEI7U0FDRjtLQUNGO0lBQ0QsSUFBSSxFQUFFLG1CQUFtQjtJQUN6QixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxLQUFLO0NBQ29CLENBQUE7QUFJMUIsTUFBTSxhQUFhLEdBQUcsQ0FBQyxJQUFrQixFQUF1QixFQUFFO0lBQ3ZFLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyw2QkFBcUIsQ0FBQyxJQUFJLENBQUE7QUFDakQsQ0FBQyxDQUFBO0FBRlksUUFBQSxhQUFhLGlCQUV6QiJ9